import BaseAccordion from 'components/Accordions/BaseAccordion';
import { joinClasses } from 'utils/componentStyles/style.utils';

const MarineAccordion = ({
  eventKey,
  title,
  subtitle,
  isRefreshing = false,
  children,
  containerClassName,
  headerClassName,
  bodyClassName,
  bodyBackground = '',
  headingLevel = 'h3',
}) => {
  return (
    <div className={joinClasses('w-100', containerClassName)}>
      <BaseAccordion
        eventKey={eventKey}
        headingLevel={headingLevel}
        bodyBackground={bodyBackground}
        header={
          <div
            className={joinClasses(
              'd-flex w-100 min-w-0 flex-column align-items-start justify-content-between gap-1 pe-2 flex-sm-row align-items-sm-center gap-sm-3',
              headerClassName,
            )}
          >
            <span className="min-w-0 fw-semibold text-break">{title}</span>
            <span className="d-flex flex-shrink-0 align-items-center gap-2 small text-secondary">
              {subtitle && <span>{subtitle}</span>}
              {isRefreshing && <span role="status">Updating...</span>}
            </span>
          </div>
        }
      >
        <div className={joinClasses('d-flex flex-column gap-3', bodyClassName)}>{children}</div>
      </BaseAccordion>
    </div>
  );
};

export default MarineAccordion;
